import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PlantedAcresService from "services/PlantedAcresService";
import {
  NO_TIMELINE_EVENTS_FOUND,
  TIMELINE_FETCH_ERROR,
} from "configurations/MessageConstants";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

const Timeline = ({ show, handleClose, plantedAcresId }) => {
  const [timelineData, setTimelineData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const selectedSite = useSelector((state) => state.site.selectedSite);
  useEffect(() => {
    const fetchTimelineData = async () => {
      try {
        const response =
          await PlantedAcresService.getTimelineDataByPlantedAcresId(
            selectedSite.id,
            plantedAcresId
          );
        setTimelineData(response);
      } catch (error) {
        console.error(TIMELINE_FETCH_ERROR, error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTimelineData();
  }, [plantedAcresId]);

  const handleCloseModal = () => {
    setTimelineData([]);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      size="lg"
      scrollable
      fullscreen="sm-down"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Timeline {timelineData.cropName && `- ${timelineData.cropName}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className="loader-container">
            <Spinner animation="border" variant="dark" size="lg" />
          </div>
        ) : timelineData?.timeline?.length === 0 ? (
          <div className="text-center py-4 text-muted">
            <i className="fa fa-calendar-times fa-2x mb-3"></i>
            <p>{NO_TIMELINE_EVENTS_FOUND}</p>
          </div>
        ) : (
          <ul className="list-unstyled">
            {timelineData?.timeline?.map((event, index) => (
              <li key={index} className="mb-4">
                <div className="d-flex align-items-center gap-2">
                  <span>
                    {event.formattedDate} - {event.eventType}
                  </span>
                  {event?.statusFrom ? (
                    <>
                      <span
                        className={`badge-outline badge-${event.statusFrom.toLowerCase()}`}
                      >
                        {event.statusFrom}
                      </span>
                      <i className="fa fa-arrow-right text-muted"></i>
                      <span
                        className={`badge-outline badge-${event.statusTo.toLowerCase()}`}
                      >
                        {event.statusTo}
                      </span>
                    </>
                  ) : (
                    <span
                      className={`badge-outline badge-${event.statusTo.toLowerCase()}`}
                    >
                      {event.statusTo}
                    </span>
                  )}
                </div>
                <div className="text-muted small"></div>
                <div className="text-muted small">{event.description}</div>
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Timeline;
